import { useEffect, useState } from 'react';
import apiClient from '../requests/api/apiClient';
import { SensorModelSchema } from '../requests/api/apiTypes';

function useSensorModels(selectedFarmId: string) {
  const [sensorModels, setSensorModels] = useState<SensorModelSchema[]>([]);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(false);
    const getSensorModels = async () => {
      if (selectedFarmId) {
        try {
          const response = await apiClient.sensorModels.sensorModelsByFarmId(selectedFarmId);
          setSensorModels(response?.data?.sensorModels ?? []);
        } catch {
          setSensorModels([]);
        }
      } else {
        setSensorModels([]);
      }
      setIsLoaded(true);
    };
    getSensorModels();
  }, [selectedFarmId]);

  return { sensorModels, isLoaded };
}

export default useSensorModels;
